import { useState } from "react";
import axiosInstance from "../api/axiosInstance";
import { useDispatch } from "react-redux";
import { logout } from "../redux/authReducer";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// import { toast } from "react-toastify";

const usePostRequest = (endpoint) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const postData = async (
    payload,
    onSuccess = () => { },
    onError = () => { },
    extraEndpoint = endpoint
  ) => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.post(extraEndpoint, payload);
      setData(response.data);
      onSuccess(response.data, response.status);
    } catch (error) {
      if (error?.response?.data?.message === "Token Error!") {
        dispatch(logout());
        navigate("/");
        toast.dismiss();
        toast.error("Session expired!");
      }
      setError(error?.response?.data || null);
      onError(error?.response?.data, error?.response?.status);
    } finally {
      setIsLoading(false);
    }
  };
  return { data, isLoading, error, postData };
};

export default usePostRequest;
